(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CityDetailController', CityDetailController);

    CityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'City', 'Prefecture'];

    function CityDetailController($scope, $rootScope, $stateParams, entity, City, Prefecture) {
        var vm = this;
        vm.city = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:cityUpdate', function(event, result) {
            vm.city = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
